export default __webpack_public_path__ + "static/media/cross.8424e3e5.svg";